import React from 'react';
import { AbaBillingPlatformFragment } from '../common';
import { CONTENT } from './constants';

export const AbaBillingPlatform = () => {
    return <AbaBillingPlatformFragment content={CONTENT} />;
};
